import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { PeopleService } from '../../../services/people.service';
import { TripMemberRoles } from '../../../entities/person.interface';
import { UserService } from '@at/user';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'at-people-tile',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './people-tile.component.html',
  styleUrl: './people-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'summary-card people-card',
  },
})
export class PeopleTileComponent {
  private readonly peopleService = inject(PeopleService);
  private readonly userService = inject(UserService);
  private readonly loggedInUser = toSignal(this.userService.user$);

  protected readonly state = this.peopleService.state;

  protected readonly count = computed(() => {
    return this.state()?.data?.members?.length ?? 0;
  });

  protected readonly organizer = computed(() => {
    const members = this.state()?.data?.members ?? [];

    return members.find((member) => member.role === TripMemberRoles.Owner);
  });

  protected readonly isOrganizerMe = computed(() => {
    const organizer = this.organizer();
    const loggedInUser = this.loggedInUser();

    return organizer && loggedInUser && organizer.email === loggedInUser.email;
  });
}
